const DHIVEHI_MONTHS = [
    "ޖަނަވަރީ",
    "ފެބްރުއަރީ",
    "މާރިޗު",
    "އޭޕްރީލް",
    "މެއި",
    "ޖޫން",
    "ޖުލައި",
    "އޯގަސްޓް",
    "ސެޕްޓެމްބަރު",
    "އޮކްޓޫބަރު",
    "ނޮވެމްބަރު",
    "ޑިސެމްބަރު",
];
/** "28 މެއި 2025" — day, Dhivehi month name, year (as used on printed forms). */
export function formatDhivehiDate(d) {
    if (!d)
        return "—";
    const date = typeof d === "string" ? new Date(d) : d;
    if (Number.isNaN(date.getTime()))
        return "—";
    return `${date.getDate()} ${DHIVEHI_MONTHS[date.getMonth()]} ${date.getFullYear()}`;
}
//# sourceMappingURL=dhivehiDate.js.map